import CustomPagination from "components/Common/CustomPagination"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import React, { useCallback, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import {
  getCuttings,
  getCuttingById,
  updateCutting,
  deleteCutting,
  clearCuttingError,
  getConfirmStockIn,
  clearPurchaseOrderError,
  saveCuttingEntryForm,
} from "store/actions"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Input,
  Row,
  Table,
} from "reactstrap"
import ModalForm from "containers/cutting/ModalForm"
import ConfirmDeleteModal from "components/Common/ConfirmDeleteModal"
import { toastMessage } from "helpers/utils"
import { debounce, sumBy } from "lodash"
import moment from "moment"
import DesignSummaryCard from "../PurchaseOrder/DesignSummaryCard"
import CuttingModalForm from "../../containers/cutting/CuttingModalForm"
import CuttingSummaryCard from "../../containers/cutting/CuttingSummaryCard"

// Cutting
const CuttingItemTab = props => {
  const [ selectedId, setSelectedId ] = useState(null)
  const [ page, setPage ] = useState(1)
  const [ pageSize, setPageSize ] = useState(10)
  const [ term, setTerm ] = useState("")

  const [ modalAddIsOpen, setModalAddIsOpen ] = useState(false)
  const [ modalEditIsOpen, setModalEditIsOpen ] = useState(false)
  const [ modalConfirmDeleteIsOpen, setModalConfirmDeleteIsOpen ] =
      useState(false)
  const [ modalConfirmStock, setModalConfirmStock ] = useState(false)
  const {
    getCuttings,
    getCuttingById,
    saveCuttingEntryForm,
    updateCutting,
    deleteCutting,
    clearCuttingError,
    purchaseOrderId,
    cutting,
    purchaseOrder,
  } = props

  const {
    items,
    clothingSizes,
    purchaseOrderItems,
    item,
    message,
    itemCount,
    pageCount,
    loading,
    summary,
  } = cutting

  const debouncedQuickSearch = useCallback(
      debounce(term => {
        setTerm(term)
        setPage(1)
      }, 1000),
      []
  )

  useEffect(() => {
  }, [])

  useEffect(() => {
    getCuttings({ purchaseOrderId, term, page, pageSize })
  }, [ page, pageSize, term ])

  useEffect(() => {
    if (message) {
      toastMessage(message)
      clearCuttingError()
    }
  }, [ message ])

  useEffect(() => {
    if (purchaseOrder.message) {
      toastMessage(purchaseOrder.message)
      // clearStockAdjustmentError()
    }
  }, [ purchaseOrder.message ])

  const handleSubmit = items => {
    const data = {
      purchaseOrderId,
      items,
    }
    saveCuttingEntryForm(data)
    setModalAddIsOpen(false)
  }

  const handleUpdate = data => {
    updateCutting(data)
    setModalEditIsOpen(false)
  }

  const handleDelete = () => {
    deleteCutting({ purchaseOrderId, id: selectedId })
    setModalConfirmDeleteIsOpen(false)
  }

  return (
      <div>
        <Card className="mb-1">
          <CardHeader className="bg-transparent border-bottom">
            <Row className="g-1">
              <Col md={ 2 }>
                <div className="search-box me-2 mb-2 d-inline-block">
                  <div className="position-relative">
                    <Input
                        type="text"
                        placeholder="Quick Search ..."
                        onChange={ e => {
                          const { value } = e.target
                          debouncedQuickSearch(value)
                        } }
                    />
                    <i className="fas fa-search search-icon"/>
                  </div>
                </div>
              </Col>
              <Col md={ 10 }>
                <div className="text-sm-end">
                  <Button
                      type="button"
                      color="primary"
                      className="me-1"
                      onClick={ () => setModalAddIsOpen(true) }
                  >
                    <i className="fas fa-plus"/> Add New
                  </Button>
                </div>
              </Col>
            </Row>
          </CardHeader>
        </Card>
        { loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary m-1" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
        ) : (
            <>
              <DesignSummaryCard purchaseOrderId={ purchaseOrderId }/>
              {
                  summary &&
                  <CuttingSummaryCard summary={ summary }/>
              }
              <Card>
                <CardHeader className="bg-transparent border-bottom">
                  <CardTitle>Item Entries</CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div
                        className="table-responsive mb-0"
                        data-pattern="priority-columns"
                    >
                      <Table
                          id="tech-companies-1"
                          className="table table-striped table-bordered table-nowrap"
                      >
                        <thead>
                        <tr>
                          <th style={ { width: "80px" } }>#</th>
                          <th className="text-center">Item Code</th>
                          <th className="text-center">Size</th>
                          <th className="text-center">Quantity</th>
                          <th className="text-center">Created Date</th>
                          <th className="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        { items.map((item, index) => {
                          const { cuttingEntries } = item
                          let num = (page - 1) * pageSize + (index + 1)

                          let total = sumBy(cuttingEntries, cuttingEntry => {
                            return cuttingEntry.quantity
                          })

                          return (
                              <tr key={ index }>
                                <td style={ { textAlign: "right" } }>{ num }</td>
                                <td>
                                  { item.itemCode } - { item.itemName }
                                </td>
                                <td>{ item.clothingSizeName }</td>
                                <td className="text-end">{ item.quantity }</td>
                                <td className="text-end">
                                  { moment
                                      .utc(item.createdDate)
                                      .local()
                                      .format("DD-MMM-yyyy h:mm:ss a") }
                                </td>

                                <td>
                                  <div className="d-flex justify-content-center">
                                    <div className="d-flex gap-3">
                                      <Link className="text-primary" to="#">
                                        <i
                                            className="mdi mdi-pencil font-size-18"
                                            id="edittooltip"
                                            onClick={ () => {
                                              getCuttingById(item.id)
                                              setModalEditIsOpen(true)
                                            } }
                                        ></i>
                                      </Link>

                                      <Link className="text-danger" to="#">
                                        <i
                                            className="mdi mdi-delete font-size-18"
                                            id="deletetooltip"
                                            onClick={ () => {
                                              setSelectedId(item.id)
                                              setModalConfirmDeleteIsOpen(true)
                                            } }
                                        ></i>
                                      </Link>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                          )
                        }) }
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  <CustomPagination
                      itemCount={ itemCount }
                      currentPage={ page }
                      totalPage={ pageCount }
                      defaultPageSize={ pageSize }
                      pageSizeOptions={ [ 5, 10, 20, 30, 40, 50, 100 ] }
                      onChangePage={ i => setPage(i) }
                      onPageSizeChange={ size => {
                        setPage(1)
                        setPageSize(size)
                      } }
                  />
                </CardBody>
              </Card>
            </>
        ) }
        <CuttingModalForm
            title="Add Design Item"
            isOpen={ modalAddIsOpen }
            toggle={ () => setModalAddIsOpen(!modalAddIsOpen) }
            clothingSizes={ clothingSizes }
            purchaseOrderItems={ purchaseOrderItems }
            purchaseOrderId={ purchaseOrderId }
            onSubmit={ handleSubmit }
        />
        { item ? (
            <ModalForm
                title="Edit Design Item"
                purchaseOrderId={ purchaseOrderId }
                item={ item }
                clothingSizes={ clothingSizes }
                isOpen={ modalEditIsOpen }
                toggle={ () => setModalEditIsOpen(!modalEditIsOpen) }
                onSubmit={ handleUpdate }
            />
        ) : null }

        <ConfirmDeleteModal
            title="Confirm Delete"
            isOpen={ modalConfirmDeleteIsOpen }
            toggle={ () => setModalConfirmDeleteIsOpen(!modalConfirmDeleteIsOpen) }
            onSubmit={ handleDelete }
        />
      </div>
  )
}

CuttingItemTab.propTypes = {
  purchaseOrderId: PropTypes.string,
  cutting: PropTypes.object,
  purchaseOrder: PropTypes.object,
  stockAdjustmentStatus: PropTypes.string,
  getCuttings: PropTypes.func,
  getCuttingById: PropTypes.func,
  updateCutting: PropTypes.func,
  deleteCutting: PropTypes.func,
  clearCuttingError: PropTypes.func,
  getConfirmStockIn: PropTypes.func,
  clearPurchaseOrderError: PropTypes.func,
  saveCuttingEntryForm: PropTypes.func,
}

const mapStateToProps = ({ cutting, purchaseOrder }) => {
  return {
    cutting,
    purchaseOrder,
  }
}

export default withRouter(
    connect(mapStateToProps, {
      getCuttings,
      getCuttingById,
      updateCutting,
      deleteCutting,
      clearCuttingError,
      getConfirmStockIn,
      saveCuttingEntryForm,
      clearPurchaseOrderError,
    })(CuttingItemTab)
)
